import { render, staticRenderFns } from "./LocationAccess.vue?vue&type=template&id=2c59b83b&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./LocationAccess.vue?vue&type=script&lang=js"
export * from "./LocationAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c59b83b",
  null
  
)

export default component.exports